import * as $ from 'jquery';

import { DataService } from './data-service';

export class WebClient {

    static savePage(id, module, json, html, draft) {
        return $.post(`/pageBuilder/saveData`,
            {
                content_json: JSON.stringify(json),
                content_html: html,
                id: id,
                module: module,
                draft: draft
            }
        );
    }

    static saveForm(id, json, html, inputs) {
        return $.post(`/formBuilder/saveForm`,
            {
                form_id: id,
                content_json: json,
                content_html: html,
                inputs: inputs
            });
    }

    static getPage(id, module) {
        return $.get(`/pageBuilder/getData?id=${id}&module=${module}`);
    }

    static getForm(id) {
        return $.get(`/formBuilder/getForm?form_id=${id}`);
    }

    static getFormFrontend(id) {
        return $.get(`/getForm?form_id=${id}`);
    }

    static getForms() {
        return $.get(`/formBuilder/getForms`);
    }

    static getProducts() {
        return $.get(`/pageBuilder/getProducts`);
    }
    static getColors() {
        return $.get(`/pageBuilder/getColors`);
    }
    static getCard(colorid) {
        return $.get(`/pageBuilder/getColorCard/${colorid}`);
    }

    static getReferences() {
        return $.get('/pageBuilder/getReferences');
    }


    static getProductsFormAssistant() {
        //return $.get(`/pageBuilder/getProductsFormAssistant`);
        return $.get(`/pageBuilder/getLifeChallengeProducts`);

    }

    static saveCroppedImage(path, serverPath, dataUrl) {
        //return $.post('/pageBuilder/saveCroppedImage', {
        let data = { image: dataUrl, image_path: path };
        if (serverPath)
            (data as any).exists_path = serverPath;

        return $.post('/ajaxPostLifeChallengeCroppedImage', data);
    }

    //card organizer

    static getCards() {
        return $.get(`/pageBuilder/getCards`);
    }

    static getCardsByPageId(type: string, pagetype : string, target?: number) {
        return $.get(`/pageBuilder/getCardsByCustomPageId?custom_page_id=${DataService.pageID}&target_group_id=${target != undefined ? target : DataService.targetGroupId}&type=${type}&page_type=${pagetype}`); //pageBuilderOverviewPage
    }

    static getCardsById(cardIds: Array<number>, type: string) {
        let str = "";
        if (cardIds && cardIds.length)
            str = cardIds.reduce((prev, curr) => prev + `card_id[]=${curr}&`, '');
        return $.get(`pageBuilder/getCardsById?${str}&type=${type}`)
    }

    static saveCardsSection(cardIds, pageId, targetGroupId,pageType) {
        return $.post('pageBuilder/saveCards', {
            assigned_cards: cardIds,
            custom_page_id: pageId,
            target_group_id: targetGroupId,
            page_type: pageType
        })
    }


    static getTargetGroups() {
        return $.get(` /pageBuilder/getTargetGroups`);
    }

    
    static getExpertiseCategories(){
        return $.get(`/pageBuilder/getExpertiseCategories`);
    }

    static getGalleries(){
        return $.get(`/pageBuilder/getGalleries`);
    }
    static getColorPalettes(){
        return $.get(`/pageBuilder/getColorPalettes`);
    }

}
